import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as LeadStructureGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general";
import { Route as LeadStructureStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/"
)({
    component: LeadStructureDetailPage,
    staticData: {
        permissions: [
            PermissionEnum.ToolStructureFormStructure,
            PermissionEnum.ToolStructureFormGeneral,
        ],
        showInSideMenu: false,
        label: "pages.tool.structure.lead.detail.title",
        redirects: [LeadStructureGeneralPage, LeadStructureStructurePage],
        defaultRedirect: LeadStructureGeneralPage,
    },
});

function LeadStructureDetailPage() {
    return <RedirectPage />;
}
